import { Rectangle } from './math/Rectangle';
import { Camera } from './rendering/Camera';
import { Sprite } from './rendering/Sprite';
import { Shader } from './rendering/Shader';
import { ERRORS } from './Errors';
import { ResourceManager } from './resources/ResourceManager';
export class WebGlRenderer {
    static create(canvas) {
        const renderer = new WebGlRenderer();
        renderer.canvas = canvas;
        renderer.canvasResized = new ResizeObserver(function () {
            renderer.resized();
        });
        renderer.canvasResized.observe(canvas); // will throw an error if canvas is null
        renderer.gl = canvas.getContext('webgl2', {
            antialias: false
        });
        if (renderer.gl === null) {
            throw new Error(ERRORS.GL_CONTEXT_MISSING);
        }
        renderer.resources = new ResourceManager(renderer.gl);
        renderer.gl.enable(renderer.gl.BLEND);
        renderer.gl.blendFunc(renderer.gl.SRC_ALPHA, renderer.gl.ONE_MINUS_SRC_ALPHA);
        renderer.gl.blendEquationSeparate(renderer.gl.FUNC_ADD, renderer.gl.FUNC_ADD);
        renderer.gl.blendFuncSeparate(renderer.gl.ONE, renderer.gl.ONE_MINUS_SRC_ALPHA, renderer.gl.ONE, renderer.gl.ONE_MINUS_SRC_ALPHA);
        renderer.camera = new Camera(new Rectangle(0, 0, canvas.clientWidth, canvas.clientHeight));
        renderer.updateViewport(canvas.clientWidth, canvas.clientHeight);
        renderer.gl.clearColor(1, 1, 1, 1);
        renderer.gl.clear(renderer.gl.COLOR_BUFFER_BIT);
        return renderer;
    }
    resized() {
        var _a, _b;
        const x = (_a = this.camera) === null || _a === void 0 ? void 0 : _a.transform.position.x;
        const y = (_b = this.camera) === null || _b === void 0 ? void 0 : _b.transform.position.y;
        const devicePixelRatio = Math.ceil(window.devicePixelRatio) || 1;
        this.camera.initialize(new Rectangle(0, 0, Math.round(this.canvas.clientWidth * devicePixelRatio), Math.round(this.canvas.clientHeight * devicePixelRatio)));
        this.updateViewport(Math.round(this.canvas.clientWidth * devicePixelRatio), Math.round(this.canvas.clientHeight * devicePixelRatio));
        this.camera.move(x, y);
    }
    // todo: used?
    unload() {
        this.canvasResized.unobserve(this.canvas);
        this.canvasResized.disconnect();
        this.resources.clearResources();
    }
    updateViewport(w, h) {
        const gl = this.getGL();
        this.canvas.width = w;
        this.canvas.height = h;
        this.camera.resize(new Rectangle(0, 0, w, h));
        gl.viewport(0, 0, w, h);
    }
    getShader() {
        if (!this.shader) {
            this.shader = new Shader(this);
        }
        return this.shader;
    }
    createSprite() {
        return new Sprite(this);
    }
    getGL() {
        return this.gl;
    }
    loadStage(stage) {
        this.stage = stage;
        this.stage.attachRenderer(this);
        this.stage.init();
    }
    setEnhancements(enhancements) {
        this.camera.brightness = enhancements.brightness;
        this.camera.contrast = enhancements.contrast;
        this.camera.gamma = enhancements.gamma;
    }
    update() {
        var _a, _b;
        const gl = this.getGL();
        gl.clearColor(1, 1, 1, 1);
        gl.clearDepth(1);
        gl.enable(gl.DEPTH_TEST);
        gl.depthFunc(gl.LEQUAL);
        gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT);
        (_a = this.stage) === null || _a === void 0 ? void 0 : _a.update();
        (_b = this.stage) === null || _b === void 0 ? void 0 : _b.draw(this);
    }
}
//# sourceMappingURL=WebGlRenderer.js.map